import React, { useState, useEffect, useRef } from 'react';
import useSWR from 'swr'
import Axios from 'axios';
import {getIndexDiff, textClean } from 'ngram-diff';
import { Citation } from '../Citation/Citation';
import { Tooltip,TooltipRefProps} from 'react-tooltip';
import {FaComments, FaEdit, FaInfo, FaBook, FaSearch, FaClipboard} from 'react-icons/fa';
import Nav from 'react-bootstrap/Nav';
import {goToGitHubEdit, copyToClipboard } from '../utils';
import { ToolTipContent } from '../ToolTipContent/ToolTipContent';
import {useNodes} from '../XTextWrapper/NodeContext'

const axiosFetcher = (url: string) => Axios.get(url).then((d) => {
  const text = d.data.trim()
  return text
});

import "./text-view.css"

export interface MyComponentProps {
  /**
   * the Url for the transcription resource
   **/
  tresourceid?: string,
  /**
  * the compare text
  **/
  compareText?: string,
  text?: string,
  /**
  * optional word start token number
  **/
  start?: number
  /**
  * optional word stop token number
  **/
  stop?: number
  /**
  * optional showContext around start and stop words
  **/
  context?: boolean
  /**
  * optional hidden
  **/
  hidden?: boolean
  compareTresourceid?: string,
  handleTextReceive?: any
  handleChangeInfo?: any // function to use for resource clicks; most likely in this case passed down to citation where the title can be clicked
  hideCitation?: boolean // set to true to not show citation
}


export const TextView: React.FC<MyComponentProps> = (props) => {
  //export const TextView = (props) => {
  const toolTipRef = useRef<TooltipRefProps>(null);
  const [text, setText] = useState<string>(textClean(props.text || "") || "")
  const [compareText, setCompareText] = useState<string>(textClean(props.compareText || "") || "")
  // const [constrainedText, setConstrainedText] = useState(props.text || "")
  // const [beforeConstrainedText, setBeforeConstrainedText] = useState("")
  // const [afterConstrainedText, setAfterConstrainedText] = useState("")
  // const [highlightedText, setHighlightedText] = useState("")
  const [diffedText, setDiffedText] = useState<any>("")
  const { data: fetchedText, error: textFetchError, isLoading: textIsLoading } = useSWR(!props.text && props.tresourceid && `https://exist.scta.info/exist/apps/scta-app/csv-pct.xq?resourceid=${props.tresourceid}`, axiosFetcher)
  const { data: fetchedCompareText, error: compareTextFetchError, isLoading: compareTextIsLoading } = useSWR(!props.compareText && props.compareTresourceid && `https://exist.scta.info/exist/apps/scta-app/csv-pct.xq?resourceid=${props.compareTresourceid}`, axiosFetcher)
  const [selectedTextRange, setSelectedTextRange] = useState<any>() // {start: "", end: ""})
  const [selectedText, setSelectedText] = useState<string>("")
  
  const {info, setHoverFocus,handleChangeDictInfo} = useNodes();
  
  const handleOnHover = () => {
    console.log("test hovering")
    if (info.focusInfo.expressionid){
      const compareExpressionId = info.focusInfo.expressionid.split("/resource/")[1]
      
      // get true false for matches
      const diffedArray = getIndexDiff(text, compareText).compare
      //convert true false into array of index numbers where match is true
      const trueIndices = diffedArray.map((value: boolean, index: number) => (value ? index + 1 : -1))
      .filter(index => index !== -1);
      // convert individual true indices to start and end pairs
      const createPairs = (arr: number[]) => {
        if (arr.length === 0) return [];

        const result = [];
        let start = arr[0];
        let end = arr[0];

        for (let i = 1; i < arr.length; i++) {
          if (arr[i] === end + 1) {
            end = arr[i];
          } else {
            result.push({ start, end });
            start = arr[i];
            end = arr[i];
          }
        }
        result.push({ start, end }); // Push the last range

        return result;
      };
      const pairsArray = createPairs(trueIndices);
      // map pairs to related expressions array needed for highlighting
      const relatedExpressions = pairsArray.map((pair, i) => {
        return ({
          text: "",
          wordRange: pair,
          selectedElementTargetId: compareExpressionId,
          isRelatedTo: ""
        })
      })
      setHoverFocus(relatedExpressions)
    }
  };
  const handleOnLeaveHover = () => {
    setHoverFocus([])
  }


  useEffect(() => {
    if (!props.text && props.tresourceid) {
      setText(textClean(fetchedText || "") || "")
    }
  }, [fetchedText])

  useEffect(() => {
    if (!props.compareText && props.compareTresourceid) {
      setCompareText(textClean(fetchedCompareText || "") || "")
    }
  }, [fetchedCompareText])

  useEffect(() => {
    if (text) {
      //setHighlightedText(highlightTextRange(text, props.start, props.stop, props.context))
      //createConstrainedText(text, props.start, props.stop)
      if (props.handleTextReceive) {
        props.handleTextReceive(text)
      }
    }
  }, [text, compareText, props.start, props.stop])

  useEffect(() => {
    if (props.compareText){
      setCompareText(props.compareText)
    }
    else{
      setCompareText("")
    }
  }, [props.compareText])

  useEffect(() => {
    if (compareText && text) {
      setDiffedText(getIndexDiff(text, compareText).base)
    }
    else if (text) {
      setDiffedText(getIndexDiff(text, "").base)
    }
    // }, [text, compareText])
  }, [text, compareText])

  // // using start and stop props, restrict text to constrained size
  // const createConstrainedText = (text: string, start: number, stop: number) => {
  //   const wordTokenStart = start
  //   const wordTokenEnd = stop
  //   const wordTokens = text.split(" ")
  //   const wordTokensClean = wordTokens.filter(Boolean)
  //   const wordTokensBefore = wordTokensClean.slice(0, wordTokenStart - 1);
  //   const wordTokensAfter = wordTokensClean.slice(wordTokenEnd)
  //   const wordTokensFocus = wordTokensClean.slice(wordTokenStart - 1, wordTokenEnd)
  //   setBeforeConstrainedText(wordTokensBefore.join(" ") + " ")
  //   setConstrainedText(wordTokensFocus.join(" "))
  //   setAfterConstrainedText(" " + wordTokensAfter.join(" "))
  // }

  // const highlightTextRange = (text, start, stop, context) => {
  //   if (text && start && stop){
  //     const wordTokenStart = start
  //     const wordTokenEnd = stop
  //     const wordTokens = text.split(" ")
  //     const wordTokensClean = wordTokens.filter(Boolean)
  //     const wordTokensBefore = wordTokensClean.slice(0, wordTokenStart - 1);
  //     const wordTokensAfter = wordTokensClean.slice(wordTokenEnd)
  //     const wordTokensFocus = wordTokensClean.slice(wordTokenStart - 1, wordTokenEnd)
  //     let textElement = ""
  //     if (context){
  //       textElement = "<p class='text'><span>" + wordTokensBefore.join(" ") + "</span> <span style='font-weight: bold'>" + wordTokensFocus.join(" ") + "</span> <span>" + wordTokensAfter.join(" ") +"</span></p>"
  //     }
  //     else{
  //       textElement = "<p class='text'>" + wordTokensFocus.join(" ") + "</p>"
  //     }
  //   return textElement
  //   }
  //   else{
  //     return "<p class='text'>" + text + "</p>"
  //   }
  // }


  const displayText = () => {
    // if (diffedText) {
    //   return <p onMouseUp={handleTextSelection} dangerouslySetInnerHTML={{__html: diffedText}} />
    // }
    // else if (highlightedText){
    //   return <p onMouseUp={handleTextSelection} dangerouslySetInnerHTML={{__html: highlightedText}}/>
    // }
    if (text) {
      const wordsArray = text.trim().split(" ").map((word, i) => {
        if (props.context !== false || ((props.start && props.stop) && i >= props.start - 1 && i <= props?.stop - 1)) {
          let className = diffedText[i] ? "base match" : "base"
          if (selectedTextRange && i >= (selectedTextRange.start - 1) && i <= (selectedTextRange.end - 1)) {
            className = className + " highlight"
          }
          if (props.context !== false && ((props.start && props.stop) && i >= props.start - 1 && i <= props.stop - 1)) {
            className = className + " focus"
          }

          return <span key={"base-" + i} data-index={i} className={className} >{word} </span>
        }

      })
      return wordsArray
    }

    // if (props.context){

    //   return <p onMouseUp={handleTextSelection} >
    //     <span dangerouslySetInnerHTML={{__html: beforeConstrainedText}} />
    //     <span style={{"fontWeight": "bold"}} dangerouslySetInnerHTML={{__html: diffedText}} />
    //     <span dangerouslySetInnerHTML={{__html: afterConstrainedText}} />
    //   </p>
    // }
    // else{
    //   return <p onMouseUp={handleTextSelection} dangerouslySetInnerHTML={{__html: diffedText}} />
    // }
  }

  /**
   * @description show tool tip relative to selected text
   * @param {{
      text: string,
      wordRange: object, 
      selectedElementTargetId: string,
    }} selectionRange - object contain needed if about selectedRange
   * @param {object} - coords object resulting from from current selection
   */
    const handleShowToolTip = (selectionCoords: any) => {
      toolTipRef.current?.close()
      toolTipRef.current?.open({
        position: {
          x: (selectionCoords.x + (selectionCoords.width))  ,
          y: (selectionCoords.y + selectionCoords.height),
        }
      }
      )
      
    }

  const handleTextSelection = () => {

    const select: any = window.getSelection()
    setSelectedText(select.toString())
    const range = select.getRangeAt(0);
    const { startContainer, endContainer } = range;

    //if (select && select.length > 0 && select.rangeCount > 0) {
      const oRect = range.getBoundingClientRect();
      
      // both conditions here are somewhat hack ways of preventing the tool tip from popping up when the users 
      // selections parts of the paragraph like the tool tip trigger or the text that pops up within the tool tip.
      // TODO: there is probably a better way to do this.
      if (range.startContainer.parentElement?.getAttributeNames().length !== 0){
        handleShowToolTip(oRect)
      }
    //}



    // function findWordIndex(textArray, charPosition) {
    //   let cumulativeCharCount = 0; // Initialize cumulative character count
    //   for (let i = 0; i < textArray.length; i++) {
    //     // Add length of current word and a space (except for the last word)
    //     cumulativeCharCount += textArray[i].length + (i < textArray.length - 1 ? 1 : 0);
    //     // If cumulative character count exceeds charPosition, return the current index
    //     if (cumulativeCharCount >= charPosition) {
    //       return i; // Return the word index (0-based)
    //     }
    //   }
    //   return -1; // Return -1 if charPosition is out of bounds
    // }

    // Helper function to find the nearest parent element with a data- attribute
    const findParentWithDataAttribute = (node: any, attributeName: any) => {
      while (node && node !== document) {
        if (node.nodeType === 1 && node.hasAttribute(attributeName)) { // Check if it's an element node and has the attribute
          return node.getAttribute(attributeName);
        }
        node = node.parentNode;
      }
      return null; // Return null if no matching parent is found
    };
    const startWord = parseInt(findParentWithDataAttribute(startContainer, 'data-index')) + 1
    const endWord = parseInt(findParentWithDataAttribute(endContainer, 'data-index')) + 1
    setSelectedTextRange({ start: startWord, end: endWord })
  }



  const displayCitation = () => {
    if (props.tresourceid) {
      let citationStart;
      let citationEnd;
      let citationWord;
      if (props.start) {
        citationStart = props.start
        citationEnd = props.stop
        citationWord = text?.split(" ")[citationStart]
      }
      if (selectedTextRange) {
        citationStart = selectedTextRange.start
        citationEnd = selectedTextRange.end
        citationWord = text?.split(" ")[citationStart]
      }
      const citationSelectionObject = {
        wordRange: {
          start: citationStart,
          end: citationEnd
        },
        text: citationWord,
      }
      return (
        <Citation tresourceid={props.tresourceid} 
        citationStyle="minimal"
        showGitHubEdit={true} 
        selectionRange={citationStart && citationSelectionObject} 
        handleChangeInfo={props.handleChangeInfo}/>
      )
    }


  }





  // Handle loading and error states
  if (textFetchError || compareTextFetchError) return <div>Error loading text</div>;
  if (textIsLoading || compareTextIsLoading) return <div>Loading...</div>;

  const relatedExpressionid = props.tresourceid && props.tresourceid.split("/resource/")[1].split("/")[0]
  return (
    <div className={props.hidden ? "hidden" : "showing"}  
    onMouseEnter={() => handleOnHover()}
    onMouseLeave={() => handleOnLeaveHover()}>
      {/* {(selectedTextRange) ? <p>focus id: {props.tresourceid}@{selectedTextRange.start}-{selectedTextRange.end}</p> : null}
        {selectedTextRange && <p onClick={() => {goToGitHubEdit(`https://github.com/scta-texts/${top}/raw/master/${item}/${item}.xml`, text.split(" ")[selectedTextRange.start - 1], block)}}>Edit on Github</p>} */}
      <p onMouseUp={handleTextSelection}>{displayText()}</p>
      {props.tresourceid && !props.hideCitation && displayCitation()}
      {props.tresourceid && 
        <Tooltip ref={toolTipRef} clickable={true} place="bottom">
          <ToolTipContent 
          handleChangeInfo={props.handleChangeInfo} 
          id={props.tresourceid} 
          info={{focusInfo: {mtFocus: "", docSource: props.tresourceid, expressionid: relatedExpressionid}}} 
          selectedTextRange={selectedTextRange} 
          selectedText={selectedText}
          handleChangeDictInfo={handleChangeDictInfo}
          />

          {/* <Nav>
          <Nav.Link onClick={() => props.handleChangeInfo(props.tresourceid + "@" + selectedTextRange.start + '-' + selectedTextRange.end)}><FaInfo/></Nav.Link>
          <Nav.Link onClick={() => goToGitHubEdit(props.tresourceid || "", selectedText.split(" ")[0] || "", props?.tresourceid?.split("/resource/")[1]?.split("/")[0] || "")}><FaEdit/></Nav.Link>
          <Nav.Link onClick={() => copyToClipboard(props.tresourceid + "@" + selectedTextRange.start + '-' + selectedTextRange.end)}><FaClipboard/></Nav.Link>
          </Nav> */}
        </Tooltip>
      }
    </div>
  );
}


// TextView.propTypes = {
//   /**
//   * the Url for the transcription resource
//   **/
//   tresourceid: PropTypes.string,
//   /**
//   * the compare text
//   **/
//   compareText: PropTypes.string,
//   /**
//   * optional word start token number
//   **/
//   start: PropTypes.number,
//   /**
//   * optional word stop token number
//   **/
//   stop: PropTypes.number,
//   /**
//   * optional showContext around start and stop words
//   **/
//   context: PropTypes.bool,
//   /**
//   * optional hidden
//   **/
//   hidden: PropTypes.bool,
//   compareTresourceid: PropTypes.string,

// }

